export enum BooleanString {
  TRUE = 'true',
  FALSE = 'false',
}
